module.exports = __webpack_public_path__ + "img/unit3-structural.b3004b81.svg";